import { createAxiosClient } from "@ntg/component-library/utilities";
import { useMutation } from "@tanstack/react-query";
import { ITwoFAPayload } from "../Declarations";

export interface IResetPasswordRequest extends ITwoFAPayload {
    NewPassword: string;
}

export const useResetPassword = () =>
    useMutation<boolean, unknown, IResetPasswordRequest>({
        mutationFn: async (input: IResetPasswordRequest): Promise<boolean> => {
            const axiosAuth = createAxiosClient("Auth");
            const response = await axiosAuth.post(
                "/UILogin/ResetPassword", // update this when defined
                {
                    BrowserFingerprint: input.BrowserFingerprint,
                    NewPassword: input.NewPassword,
                    Password: input.Password,
                    UserAgent: input.UserAgent,
                    UserID: input.UserID,
                    UserName: input.UserName,
                },
                {
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            );
            return response.data;
        },
    });
